<script>
  $: ({ headers, columns, promise, rows, ascUnicode } = $$props);
  export let skeletonRows = 5;
</script>

<table style="--gtc:{columns}">
  <thead>
    <tr>
      {#each headers as header}
        <th class:active={header.active}>
          <div class="cell">
            <div class="gradient" />
          </div>
        </th>
      {/each}
    </tr>
  </thead>
  <tbody>
    {#each Array(skeletonRows) as row}
      <tr>
        {#each headers as header}
          <td>
            <div class="cell">
              <div class="gradient" />
            </div>
          </td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>

<style>
  table,
  thead,
  tbody,
  tr {
    display: grid;
  }
  table {
    border-collapse: separate;
    overflow: hidden;
  }
  thead {
    position: sticky;
    top: 0;
    background-color: white;
  }

  th {
    cursor: pointer;
  }

  tr {
    grid-template-columns: var(--gtc);
  }

  td,
  th {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  tr td:first-child,
  tr th:first-child {
    text-align: left;
  }

  th:last-child:after {
    content: "";
    width: 14px;
    height: 2px;
    background: black;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  th {
    padding: 9px 0px 7px 0px;
  }
  td {
    /* padding reset */
    padding: 0 !important;
    vertical-align: middle;
  }

  .cell {
    height: 46px;
    word-wrap: break-word;
    line-height: 1;
    box-sizing: border-box;
    padding-top: 8px;
  }
  .active {
    border-bottom: 2px solid #fc3;
  }
  .gradient {
    width: 80%;
    height: 23px;

    animation-duration: 1.8s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);
    background-size: 1000px 640px;

    position: relative;
  }

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
</style>
